import {makeChannelOptionHtml} from "./ChannelOptionHtml";

export function makeHRSChannelOptionHtml() {
    const innerHtml = '<span style="color: #CC092F;font-weight:bold;">HRS</span>';
    const html = makeChannelOptionHtml(innerHtml, [
        'background: white;',
    ]);
    return html;
}
